import settings from './settings/actions'
import table from './table/actions'
import details from './details/actions'

export default {
  settings,
  table,
  details
}
